import DOMPurify from 'isomorphic-dompurify'

/**
 * APIから取得したHTML文字列をDOMPurifyでサニタイズして返す。
 * `dangerouslySetInnerHTML` で埋め込む前に必ず使用すること。
 * isomorphic-dompurify を使用することでSSR/プリレンダリング環境でも安全にサニタイズされる。
 */
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html)
}
